<template>
	<div>
    <div class="overview-card">
        <div class="overview-box">
            <div class="overview-icon">
                <div class="overview-text-title">{{ this.title }}</div>
            </div>
        </div>
    </div>
	</div>
</template>

<script>
//import Bright from '@/components/page/Bright.js'
//import InfoCardComp from '@/views/pages/InfoCardComp.vue'

export default {
	//extends: Bright,
  props: ["title"],
	components: {
		//InfoCardComp,
	},
  mounted() {
		
  },
  methods: {
		
	}
}
</script>

<style scoped>
.overview-card {
  position: relative;
  width: 100%;
  height: 40px;
  background: transparent;
  border-bottom:1.5px solid #409EFF;
  border-radius: 0px;
}

.overview-card  .overview-box {
  position: absolute;
  inset: 0px;
  background: transparent;
  border-radius:0px;
}

.overview-card  .overview-box .overview-icon {
  position: absolute;
  width: 200px;
  height: 40px;
  bottom:0;
  background: white;
  border-top-left-radius:6px;
  border-top-right-radius:6px;
  border-top: 0px solid #409EFF;
  border-left: 0px solid #409EFF;
  border-right: 0px solid #409EFF;
  
  display: flex;
  justify-content: left; /* Horizontally center content */
  align-items: center; /* Vertically center content */
  height: 40px; /* Set the container height to the viewport height */
}

.overview-card  .overview-box .overview-icon::before {
  content: "";
  position: absolute;
  background: transparent;
  bottom: 0px;
  right: -10px;
  height: 10px;
  width: 10px;
  border-bottom-left-radius: 10px;
  box-shadow: -2px 2px 0 2px green;
  z-index:-1;
}

.overview-text-title {
  padding:2px 15px;
  color:#409EFF;
  font-weight: 600;
}
</style>